import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import "./Legal.css";

function Privacy() {


  useEffect(() => {
   window.scrollTo(0, 0);
  }, []);
 return (
  <div className="legal-page">
   <Helmet>
    <title>Privacy Policy | SportingHip</title>
    <meta
     name="description"
     content="Read the SportingHip Privacy Policy to understand how we collect, use, and protect information."
    />
   </Helmet>

   <div className="legal-back-corner">
    <Link to="/">← Back to directory</Link>
   </div>

   <main className="legal-container legal-content-card">
    <h1 className="legal-title">Privacy Policy</h1>
    <p className="legal-date">Effective date: March 4, 2026</p>

    <p>
     SportingHip (“we,” “us,” or “our”) provides a sports directory and
     related tools that help people discover local sports programs and help
     organizations share program information. This Privacy Policy explains
     how we collect, use, and share information when you use SportingHip.
    </p>

    <h3>Information we collect</h3>
    <ul>
     <li>
      <strong>Contact information:</strong> name, email address, and
      messages you send to us.
     </li>
     <li>
      <strong>Organization and listing information:</strong> program
      details, locations, websites, social links, registration links,
      schedules, and updates submitted to us.
     </li>
     <li>
      <strong>Account information:</strong> if accounts are available,
      we may collect login details and basic profile information.
     </li>
     <li>
      <strong>Usage information:</strong> pages viewed, clicks,
      browser/device information, approximate location, and similar
      analytics data.
     </li>
    </ul>

    <h3>How we use information</h3>
    <ul>
     <li>Provide, operate, and improve SportingHip</li>
     <li>Create, update, and maintain directory listings</li>
     <li>Respond to questions, listing updates, and support requests</li>
     <li>Help visitors find relevant sports programs</li>
     <li>Monitor performance, prevent spam, and improve security</li>
     <li>Develop future tools for sports organizations</li>
    </ul>

    <h3>Public listing information</h3>
    <p>
     Directory listings may include public information such as organization
     names, sports offered, program details, locations, websites, social
     media links, schedules, fees, and registration information. Please do
     not send sensitive personal information that should not appear publicly.
    </p>

    <h3>Cookies and analytics</h3>
    <p>
     We may use cookies and similar technologies to understand how visitors
     use SportingHip, improve the website, remember preferences, and support
     basic functionality. You can limit cookies through your browser
     settings, but some features may not work properly.
    </p>

    <h3>How we share information</h3>
    <p>
     We do <strong>not</strong> sell your personal information. We may share
     information only in limited situations:
    </p>

    <ul>
     <li>
      <strong>Service providers:</strong> companies that help us operate
      SportingHip, such as hosting, analytics, email, and payment tools.
     </li>
     <li>
      <strong>Legal or safety reasons:</strong> when required by law or to
      protect SportingHip, users, or the public.
     </li>
     <li>
      <strong>Business transfers:</strong> if SportingHip is involved in a
      merger, acquisition, financing, or sale of assets.
     </li>
    </ul>

    <h3>Data retention</h3>
    <p>
     We keep information for as long as needed to operate SportingHip,
     maintain listings, respond to requests, comply with legal obligations,
     and protect the service. We may also keep aggregated or anonymized data
     that does not identify you.
    </p>

    <h3>Your choices</h3>
    <p>
     You may contact us to request access, correction, or deletion of
     personal information you have provided. Some information may remain in
     backups, logs, or records where required for legal, security, or
     operational reasons.
    </p>

    <h3>Children</h3>
    <p>
     SportingHip is not intended for children under 13. We do not knowingly
     collect personal information from children under 13.
    </p>

    <h3>Changes to this policy</h3>
    <p>
     We may update this Privacy Policy from time to time. When we do, we may
     update the effective date above.
    </p>

    <h3>Contact</h3>
    <p>
     For privacy questions or requests, email{" "}
     <a href="mailto:hello@sportinghip.com">hello@sportinghip.com</a>.
    </p>
   </main>
  </div>
 );
}

export default Privacy;